import React from 'react';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { segmentTrack } from 'flow/actions/segment-actions';
import Button from 'flow/components/ui-components/Button';
import Tooltip from 'flow/components/ui-components/Tooltip';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import { selectOwnUserHasTicketPermission } from 'flow/selectors/ticket-permission-selectors';
import { TicketKey } from 'flow/types/EntityKeys';
import { TICKET_STRINGS } from 'flow/utils/segment-utils';
import { twMerge } from 'tailwind-merge';

interface Props {
    ticketKey: TicketKey;
    disabled: boolean;
}

const WhatsAppTemplatesButton = ({ ticketKey, disabled }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const { openModal } = useModal();
    const canReply = useAppSelector((state) =>
        selectOwnUserHasTicketPermission(state, ticketKey, 'reply'),
    );

    const handleWhatsAppTemplateClickIcon = () => {
        dispatch(
            segmentTrack(TICKET_STRINGS.WHATSAPP_TEMPLATE_ICON, {
                component: 'Ticket footer',
            }),
        );

        openModal('whatsAppTemplate', { ticketKey });
    };

    return (
        <Tooltip label={i18next.t('tickets.whatsapp.whatsapp_template_plural')}>
            <Button
                onClick={handleWhatsAppTemplateClickIcon}
                iconKey="article"
                className={twMerge(
                    'rounded-sm bg-gray-200 hover:bg-gray-300',
                    disabled || !canReply ? 'fill-gray-200' : '',
                )}
                disabled={disabled || !canReply}
            />
        </Tooltip>
    );
};

export default WhatsAppTemplatesButton;
